import Paper from "@mui/material/Paper"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { CustomBackTestResultRow } from "./CustomBackTestResultRow"
import { BacktestStore } from "../../redux/reducers/backtesting/backtestingReducer"
import { alpha, useTheme } from "@mui/material/styles"


interface BackTestingTableProps
{
  results: BacktestStore[]
  isAdmin?: boolean
  onOpenItem: (item: BacktestStore) => void
}

export const BackTestingTable = ({ results, onOpenItem, isAdmin } : BackTestingTableProps) => {
  const theme = useTheme()
  return (
    <TableContainer
      component={Paper}
      sx={{
        ...styles.table,
        borderRadius: "12px",
        border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === 'dark' ? 0.08 : 0.6)}`,
        backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === 'dark' ? 0.03 : 0.7),
      }}
    >
    <Table sx={{ minWidth: 650 }} aria-label="simple table" stickyHeader >
      <TableHead>
        <TableRow>
          { isAdmin && <TableCell sx={styles.header(theme)}>User</TableCell> }
          <TableCell sx={styles.header(theme)}>Test Name</TableCell>
          <TableCell align="right" sx={styles.header(theme)}>Trading Pair</TableCell>
          <TableCell align="right" sx={styles.header(theme)}>Schedule</TableCell>
          <TableCell align="right" sx={styles.header(theme)}>Last Run</TableCell>
          <TableCell align="right" sx={styles.header(theme)}>Next Run</TableCell>
          <TableCell align="right" sx={styles.header(theme)}>Take Profit</TableCell>
          <TableCell align="right" sx={styles.header(theme)}>Stop Loss</TableCell>
          <TableCell align="right" sx={styles.header(theme)}>Min Sell Threshold</TableCell>
          <TableCell align="right" sx={styles.header(theme)}>Alerts Enabled</TableCell>
          <TableCell align="right" sx={styles.header(theme)}>Schedule Active</TableCell>

        </TableRow>
      </TableHead>
      <TableBody >
        {results && results.map((row, key) => <CustomBackTestResultRow key={key} row={row} onOpenItem={onOpenItem} isAdmin={isAdmin} />)}
      </TableBody>
    </Table>
  </TableContainer>
  )
}

const styles = {
  header: (theme: any) => ({
    fontWeight: "700",
    backgroundColor: alpha(theme.palette.common.black, theme.palette.mode === 'dark' ? 0.16 : 0.03),
    backdropFilter: "blur(10px)",
  }),
  table: {
    overflow: "auto",
    height: "75vh",
    marginTop: 16,
    marginBottom: 28,
  }
}
